<template>
  <section class="hero text-center text-light">
    <div class="hero-bg"/>
    <div class="hero-particles-container">
      <canvas id="hero-particles"/>
    </div>
    <div class="container-sm">
      <div class="hero-inner">
        <div class="hero-copy">
          <h1 class="hero-title mt-0">
            Welcome, future
            <span class="text-primary">Hero</span>
          </h1>
          <p class="hero-paragraph">
            Lets get you registered.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {}
</script>

<style scoped>

</style>
